export const AGENDAS_FETCH_REQUEST = 'AGENDAS_FETCH_REQUEST';
export const AGENDAS_FETCH_SUCCESS = 'AGENDAS_FETCH_SUCCESS';
export const AGENDAS_FETCH_FAILURE = 'AGENDAS_FETCH_FAILURE';
export const AGENDAS_CREATE_REQUEST = 'AGENDAS_CREATE_REQUEST';
export const AGENDAS_CREATE_SUCCESS = 'AGENDAS_CREATE_SUCCESS';
export const AGENDAS_CREATE_FAILURE = 'AGENDAS_CREATE_FAILURE';
export const AGENDAS_UPDATE_REQUEST = 'AGENDAS_UPDATE_REQUEST';
export const AGENDAS_UPDATE_SUCCESS = 'AGENDAS_UPDATE_SUCCESS';
export const AGENDAS_UPDATE_FAILURE = 'AGENDAS_UPDATE_FAILURE';
export const AGENDAS_DELETE_REQUEST = 'AGENDAS_DELETE_REQUEST';
export const AGENDAS_DELETE_SUCCESS = 'AGENDAS_DELETE_SUCCESS';
export const AGENDAS_DELETE_FAILURE = 'AGENDAS_DELETE_FAILURE';
export const AGENDAS_SET_LOADING = 'AGENDAS_SET_LOADING';
export const AGENDAS_SET_ERROR = 'AGENDAS_SET_ERROR';
export const AGENDAS_CLEAR_ERROR = 'AGENDAS_CLEAR_ERROR';